// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "fleetdashboard/v1/fleetdashboard.proto" (package "fleetdashboard.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private fleet dashboard RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { FleetDashboardService } from "./fleetdashboard";
import type { GetOrgFragmentUsageResponse } from "./fleetdashboard";
import type { GetOrgFragmentUsageRequest } from "./fleetdashboard";
import type { GetOrgFragmentVersionSummariesResponse } from "./fleetdashboard";
import type { GetOrgFragmentVersionSummariesRequest } from "./fleetdashboard";
import type { GetOrgModuleVersionSummariesResponse } from "./fleetdashboard";
import type { GetOrgModuleVersionSummariesRequest } from "./fleetdashboard";
import type { GetConfigAssistantStatsResponse } from "./fleetdashboard";
import type { GetConfigAssistantStatsRequest } from "./fleetdashboard";
import type { SubmitConfigAssistantFeedbackResponse } from "./fleetdashboard";
import type { SubmitConfigAssistantFeedbackRequest } from "./fleetdashboard";
import type { GetConfigAssistantConversationResponse } from "./fleetdashboard";
import type { GetConfigAssistantConversationRequest } from "./fleetdashboard";
import type { ListConfigAssistantConversationsResponse } from "./fleetdashboard";
import type { ListConfigAssistantConversationsRequest } from "./fleetdashboard";
import type { RunConfigAssistantTurnResponse } from "./fleetdashboard";
import type { RunConfigAssistantTurnRequest } from "./fleetdashboard";
import type { MergeFragmentConfigResponse } from "./fleetdashboard";
import type { MergeFragmentConfigRequest } from "./fleetdashboard";
import type { MergeRobotPartConfigResponse } from "./fleetdashboard";
import type { MergeRobotPartConfigRequest } from "./fleetdashboard";
import type { CheckFragmentConfigMergeSafetyResponse } from "./fleetdashboard";
import type { CheckFragmentConfigMergeSafetyRequest } from "./fleetdashboard";
import type { CheckRobotPartConfigMergeSafetyResponse } from "./fleetdashboard";
import type { CheckRobotPartConfigMergeSafetyRequest } from "./fleetdashboard";
import type { GetDebugConfigurationResponse } from "./fleetdashboard";
import type { GetDebugConfigurationRequest } from "./fleetdashboard";
import type { SearchConfigurationBlocksResponse } from "./fleetdashboard";
import type { SearchConfigurationBlocksRequest } from "./fleetdashboard";
import type { ListLocationMembersResponse } from "./fleetdashboard";
import type { ListLocationMembersRequest } from "./fleetdashboard";
import type { ListLocationKeysResponse } from "./fleetdashboard";
import type { ListLocationKeysRequest } from "./fleetdashboard";
import type { ResolveFragmentsResponse } from "./fleetdashboard";
import type { ResolveFragmentsRequest } from "./fleetdashboard";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetOrganizationSummaryResponse } from "./fleetdashboard";
import type { GetOrganizationSummaryRequest } from "./fleetdashboard";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service fleetdashboard.v1.FleetDashboardService
 */
export interface IFleetDashboardServiceClient {
    /**
     * List information regarding all locations, their machines and their parts in an organization relevant to the fleet dashboard aggregation page
     *
     * @generated from protobuf rpc: GetOrganizationSummary(fleetdashboard.v1.GetOrganizationSummaryRequest) returns (fleetdashboard.v1.GetOrganizationSummaryResponse);
     */
    getOrganizationSummary(input: GetOrganizationSummaryRequest, options?: RpcOptions): UnaryCall<GetOrganizationSummaryRequest, GetOrganizationSummaryResponse>;
    /**
     * @generated from protobuf rpc: ResolveFragments(fleetdashboard.v1.ResolveFragmentsRequest) returns (fleetdashboard.v1.ResolveFragmentsResponse);
     */
    resolveFragments(input: ResolveFragmentsRequest, options?: RpcOptions): UnaryCall<ResolveFragmentsRequest, ResolveFragmentsResponse>;
    /**
     * @generated from protobuf rpc: ListLocationKeys(fleetdashboard.v1.ListLocationKeysRequest) returns (fleetdashboard.v1.ListLocationKeysResponse);
     */
    listLocationKeys(input: ListLocationKeysRequest, options?: RpcOptions): UnaryCall<ListLocationKeysRequest, ListLocationKeysResponse>;
    /**
     * @generated from protobuf rpc: ListLocationMembers(fleetdashboard.v1.ListLocationMembersRequest) returns (fleetdashboard.v1.ListLocationMembersResponse);
     */
    listLocationMembers(input: ListLocationMembersRequest, options?: RpcOptions): UnaryCall<ListLocationMembersRequest, ListLocationMembersResponse>;
    /**
     * @generated from protobuf rpc: SearchConfigurationBlocks(fleetdashboard.v1.SearchConfigurationBlocksRequest) returns (fleetdashboard.v1.SearchConfigurationBlocksResponse);
     */
    searchConfigurationBlocks(input: SearchConfigurationBlocksRequest, options?: RpcOptions): UnaryCall<SearchConfigurationBlocksRequest, SearchConfigurationBlocksResponse>;
    /**
     * Returns the fully resolved debug configuration for a robot part, using the part's stored platform info.
     *
     * @generated from protobuf rpc: GetDebugConfiguration(fleetdashboard.v1.GetDebugConfigurationRequest) returns (fleetdashboard.v1.GetDebugConfigurationResponse);
     */
    getDebugConfiguration(input: GetDebugConfigurationRequest, options?: RpcOptions): UnaryCall<GetDebugConfigurationRequest, GetDebugConfigurationResponse>;
    /**
     * Check whether a proposed robot part config change can be safely merged
     * with concurrent changes that occurred since base_update_time.
     *
     * @generated from protobuf rpc: CheckRobotPartConfigMergeSafety(fleetdashboard.v1.CheckRobotPartConfigMergeSafetyRequest) returns (fleetdashboard.v1.CheckRobotPartConfigMergeSafetyResponse);
     */
    checkRobotPartConfigMergeSafety(input: CheckRobotPartConfigMergeSafetyRequest, options?: RpcOptions): UnaryCall<CheckRobotPartConfigMergeSafetyRequest, CheckRobotPartConfigMergeSafetyResponse>;
    /**
     * Check whether a proposed fragment config change can be safely merged with
     * concurrent changes that occurred since base_update_time.
     *
     * @generated from protobuf rpc: CheckFragmentConfigMergeSafety(fleetdashboard.v1.CheckFragmentConfigMergeSafetyRequest) returns (fleetdashboard.v1.CheckFragmentConfigMergeSafetyResponse);
     */
    checkFragmentConfigMergeSafety(input: CheckFragmentConfigMergeSafetyRequest, options?: RpcOptions): UnaryCall<CheckFragmentConfigMergeSafetyRequest, CheckFragmentConfigMergeSafetyResponse>;
    /**
     * Atomically merge a proposed robot part config with the current DB config,
     * if the changes don't overlap. Fails if merge is unsafe.
     *
     * @generated from protobuf rpc: MergeRobotPartConfig(fleetdashboard.v1.MergeRobotPartConfigRequest) returns (fleetdashboard.v1.MergeRobotPartConfigResponse);
     */
    mergeRobotPartConfig(input: MergeRobotPartConfigRequest, options?: RpcOptions): UnaryCall<MergeRobotPartConfigRequest, MergeRobotPartConfigResponse>;
    /**
     * Atomically merge a proposed fragment config with the current DB config,
     * if the changes don't overlap. Fails if merge is unsafe.
     *
     * @generated from protobuf rpc: MergeFragmentConfig(fleetdashboard.v1.MergeFragmentConfigRequest) returns (fleetdashboard.v1.MergeFragmentConfigResponse);
     */
    mergeFragmentConfig(input: MergeFragmentConfigRequest, options?: RpcOptions): UnaryCall<MergeFragmentConfigRequest, MergeFragmentConfigResponse>;
    /**
     * Run one turn of the multi-turn config AI assistant chat. Stateless: the client replays the full
     * conversation each turn; the backend runs any backend tools in-loop and returns when the model
     * finishes or needs a client-side (frontend) tool. Unary today; this can return to server
     * streaming (incremental text + tool progress) if/when tool-heavy turns make that worthwhile.
     *
     * @generated from protobuf rpc: RunConfigAssistantTurn(fleetdashboard.v1.RunConfigAssistantTurnRequest) returns (fleetdashboard.v1.RunConfigAssistantTurnResponse);
     */
    runConfigAssistantTurn(input: RunConfigAssistantTurnRequest, options?: RpcOptions): UnaryCall<RunConfigAssistantTurnRequest, RunConfigAssistantTurnResponse>;
    /**
     * List the calling user's past config assistant conversations for one config, newest first.
     *
     * @generated from protobuf rpc: ListConfigAssistantConversations(fleetdashboard.v1.ListConfigAssistantConversationsRequest) returns (fleetdashboard.v1.ListConfigAssistantConversationsResponse);
     */
    listConfigAssistantConversations(input: ListConfigAssistantConversationsRequest, options?: RpcOptions): UnaryCall<ListConfigAssistantConversationsRequest, ListConfigAssistantConversationsResponse>;
    /**
     * Get one of the calling user's past conversations in full.
     *
     * @generated from protobuf rpc: GetConfigAssistantConversation(fleetdashboard.v1.GetConfigAssistantConversationRequest) returns (fleetdashboard.v1.GetConfigAssistantConversationResponse);
     */
    getConfigAssistantConversation(input: GetConfigAssistantConversationRequest, options?: RpcOptions): UnaryCall<GetConfigAssistantConversationRequest, GetConfigAssistantConversationResponse>;
    /**
     * Record a Viam-employee's thumbs-up/down feedback with a note on a config assistant conversation.
     *
     * @generated from protobuf rpc: SubmitConfigAssistantFeedback(fleetdashboard.v1.SubmitConfigAssistantFeedbackRequest) returns (fleetdashboard.v1.SubmitConfigAssistantFeedbackResponse);
     */
    submitConfigAssistantFeedback(input: SubmitConfigAssistantFeedbackRequest, options?: RpcOptions): UnaryCall<SubmitConfigAssistantFeedbackRequest, SubmitConfigAssistantFeedbackResponse>;
    /**
     * Aggregate usage stats over all config assistant conversations, for the internal AI-assistant
     * stats dashboard. Restricted to Viam employees.
     *
     * @generated from protobuf rpc: GetConfigAssistantStats(fleetdashboard.v1.GetConfigAssistantStatsRequest) returns (fleetdashboard.v1.GetConfigAssistantStatsResponse);
     */
    getConfigAssistantStats(input: GetConfigAssistantStatsRequest, options?: RpcOptions): UnaryCall<GetConfigAssistantStatsRequest, GetConfigAssistantStatsResponse>;
    /**
     * Get a summary of the versions of all modules that are in use by parts in the organization.
     *
     * @generated from protobuf rpc: GetOrgModuleVersionSummaries(fleetdashboard.v1.GetOrgModuleVersionSummariesRequest) returns (fleetdashboard.v1.GetOrgModuleVersionSummariesResponse);
     */
    getOrgModuleVersionSummaries(input: GetOrgModuleVersionSummariesRequest, options?: RpcOptions): UnaryCall<GetOrgModuleVersionSummariesRequest, GetOrgModuleVersionSummariesResponse>;
    /**
     * Get a summary of the versions of all fragments that are in use by parts in the organization.
     *
     * @generated from protobuf rpc: GetOrgFragmentVersionSummaries(fleetdashboard.v1.GetOrgFragmentVersionSummariesRequest) returns (fleetdashboard.v1.GetOrgFragmentVersionSummariesResponse);
     */
    getOrgFragmentVersionSummaries(input: GetOrgFragmentVersionSummariesRequest, options?: RpcOptions): UnaryCall<GetOrgFragmentVersionSummariesRequest, GetOrgFragmentVersionSummariesResponse>;
    /**
     * Per-part usage of a single fragment across the org's accessible fleet.
     *
     * @generated from protobuf rpc: GetOrgFragmentUsage(fleetdashboard.v1.GetOrgFragmentUsageRequest) returns (fleetdashboard.v1.GetOrgFragmentUsageResponse);
     */
    getOrgFragmentUsage(input: GetOrgFragmentUsageRequest, options?: RpcOptions): UnaryCall<GetOrgFragmentUsageRequest, GetOrgFragmentUsageResponse>;
}
/**
 * @generated from protobuf service fleetdashboard.v1.FleetDashboardService
 */
export class FleetDashboardServiceClient implements IFleetDashboardServiceClient, ServiceInfo {
    typeName = FleetDashboardService.typeName;
    methods = FleetDashboardService.methods;
    options = FleetDashboardService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * List information regarding all locations, their machines and their parts in an organization relevant to the fleet dashboard aggregation page
     *
     * @generated from protobuf rpc: GetOrganizationSummary(fleetdashboard.v1.GetOrganizationSummaryRequest) returns (fleetdashboard.v1.GetOrganizationSummaryResponse);
     */
    getOrganizationSummary(input: GetOrganizationSummaryRequest, options?: RpcOptions): UnaryCall<GetOrganizationSummaryRequest, GetOrganizationSummaryResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationSummaryRequest, GetOrganizationSummaryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResolveFragments(fleetdashboard.v1.ResolveFragmentsRequest) returns (fleetdashboard.v1.ResolveFragmentsResponse);
     */
    resolveFragments(input: ResolveFragmentsRequest, options?: RpcOptions): UnaryCall<ResolveFragmentsRequest, ResolveFragmentsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResolveFragmentsRequest, ResolveFragmentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListLocationKeys(fleetdashboard.v1.ListLocationKeysRequest) returns (fleetdashboard.v1.ListLocationKeysResponse);
     */
    listLocationKeys(input: ListLocationKeysRequest, options?: RpcOptions): UnaryCall<ListLocationKeysRequest, ListLocationKeysResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListLocationKeysRequest, ListLocationKeysResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListLocationMembers(fleetdashboard.v1.ListLocationMembersRequest) returns (fleetdashboard.v1.ListLocationMembersResponse);
     */
    listLocationMembers(input: ListLocationMembersRequest, options?: RpcOptions): UnaryCall<ListLocationMembersRequest, ListLocationMembersResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListLocationMembersRequest, ListLocationMembersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchConfigurationBlocks(fleetdashboard.v1.SearchConfigurationBlocksRequest) returns (fleetdashboard.v1.SearchConfigurationBlocksResponse);
     */
    searchConfigurationBlocks(input: SearchConfigurationBlocksRequest, options?: RpcOptions): UnaryCall<SearchConfigurationBlocksRequest, SearchConfigurationBlocksResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchConfigurationBlocksRequest, SearchConfigurationBlocksResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Returns the fully resolved debug configuration for a robot part, using the part's stored platform info.
     *
     * @generated from protobuf rpc: GetDebugConfiguration(fleetdashboard.v1.GetDebugConfigurationRequest) returns (fleetdashboard.v1.GetDebugConfigurationResponse);
     */
    getDebugConfiguration(input: GetDebugConfigurationRequest, options?: RpcOptions): UnaryCall<GetDebugConfigurationRequest, GetDebugConfigurationResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDebugConfigurationRequest, GetDebugConfigurationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Check whether a proposed robot part config change can be safely merged
     * with concurrent changes that occurred since base_update_time.
     *
     * @generated from protobuf rpc: CheckRobotPartConfigMergeSafety(fleetdashboard.v1.CheckRobotPartConfigMergeSafetyRequest) returns (fleetdashboard.v1.CheckRobotPartConfigMergeSafetyResponse);
     */
    checkRobotPartConfigMergeSafety(input: CheckRobotPartConfigMergeSafetyRequest, options?: RpcOptions): UnaryCall<CheckRobotPartConfigMergeSafetyRequest, CheckRobotPartConfigMergeSafetyResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckRobotPartConfigMergeSafetyRequest, CheckRobotPartConfigMergeSafetyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Check whether a proposed fragment config change can be safely merged with
     * concurrent changes that occurred since base_update_time.
     *
     * @generated from protobuf rpc: CheckFragmentConfigMergeSafety(fleetdashboard.v1.CheckFragmentConfigMergeSafetyRequest) returns (fleetdashboard.v1.CheckFragmentConfigMergeSafetyResponse);
     */
    checkFragmentConfigMergeSafety(input: CheckFragmentConfigMergeSafetyRequest, options?: RpcOptions): UnaryCall<CheckFragmentConfigMergeSafetyRequest, CheckFragmentConfigMergeSafetyResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckFragmentConfigMergeSafetyRequest, CheckFragmentConfigMergeSafetyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Atomically merge a proposed robot part config with the current DB config,
     * if the changes don't overlap. Fails if merge is unsafe.
     *
     * @generated from protobuf rpc: MergeRobotPartConfig(fleetdashboard.v1.MergeRobotPartConfigRequest) returns (fleetdashboard.v1.MergeRobotPartConfigResponse);
     */
    mergeRobotPartConfig(input: MergeRobotPartConfigRequest, options?: RpcOptions): UnaryCall<MergeRobotPartConfigRequest, MergeRobotPartConfigResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<MergeRobotPartConfigRequest, MergeRobotPartConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Atomically merge a proposed fragment config with the current DB config,
     * if the changes don't overlap. Fails if merge is unsafe.
     *
     * @generated from protobuf rpc: MergeFragmentConfig(fleetdashboard.v1.MergeFragmentConfigRequest) returns (fleetdashboard.v1.MergeFragmentConfigResponse);
     */
    mergeFragmentConfig(input: MergeFragmentConfigRequest, options?: RpcOptions): UnaryCall<MergeFragmentConfigRequest, MergeFragmentConfigResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<MergeFragmentConfigRequest, MergeFragmentConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Run one turn of the multi-turn config AI assistant chat. Stateless: the client replays the full
     * conversation each turn; the backend runs any backend tools in-loop and returns when the model
     * finishes or needs a client-side (frontend) tool. Unary today; this can return to server
     * streaming (incremental text + tool progress) if/when tool-heavy turns make that worthwhile.
     *
     * @generated from protobuf rpc: RunConfigAssistantTurn(fleetdashboard.v1.RunConfigAssistantTurnRequest) returns (fleetdashboard.v1.RunConfigAssistantTurnResponse);
     */
    runConfigAssistantTurn(input: RunConfigAssistantTurnRequest, options?: RpcOptions): UnaryCall<RunConfigAssistantTurnRequest, RunConfigAssistantTurnResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<RunConfigAssistantTurnRequest, RunConfigAssistantTurnResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List the calling user's past config assistant conversations for one config, newest first.
     *
     * @generated from protobuf rpc: ListConfigAssistantConversations(fleetdashboard.v1.ListConfigAssistantConversationsRequest) returns (fleetdashboard.v1.ListConfigAssistantConversationsResponse);
     */
    listConfigAssistantConversations(input: ListConfigAssistantConversationsRequest, options?: RpcOptions): UnaryCall<ListConfigAssistantConversationsRequest, ListConfigAssistantConversationsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListConfigAssistantConversationsRequest, ListConfigAssistantConversationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get one of the calling user's past conversations in full.
     *
     * @generated from protobuf rpc: GetConfigAssistantConversation(fleetdashboard.v1.GetConfigAssistantConversationRequest) returns (fleetdashboard.v1.GetConfigAssistantConversationResponse);
     */
    getConfigAssistantConversation(input: GetConfigAssistantConversationRequest, options?: RpcOptions): UnaryCall<GetConfigAssistantConversationRequest, GetConfigAssistantConversationResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConfigAssistantConversationRequest, GetConfigAssistantConversationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Record a Viam-employee's thumbs-up/down feedback with a note on a config assistant conversation.
     *
     * @generated from protobuf rpc: SubmitConfigAssistantFeedback(fleetdashboard.v1.SubmitConfigAssistantFeedbackRequest) returns (fleetdashboard.v1.SubmitConfigAssistantFeedbackResponse);
     */
    submitConfigAssistantFeedback(input: SubmitConfigAssistantFeedbackRequest, options?: RpcOptions): UnaryCall<SubmitConfigAssistantFeedbackRequest, SubmitConfigAssistantFeedbackResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<SubmitConfigAssistantFeedbackRequest, SubmitConfigAssistantFeedbackResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Aggregate usage stats over all config assistant conversations, for the internal AI-assistant
     * stats dashboard. Restricted to Viam employees.
     *
     * @generated from protobuf rpc: GetConfigAssistantStats(fleetdashboard.v1.GetConfigAssistantStatsRequest) returns (fleetdashboard.v1.GetConfigAssistantStatsResponse);
     */
    getConfigAssistantStats(input: GetConfigAssistantStatsRequest, options?: RpcOptions): UnaryCall<GetConfigAssistantStatsRequest, GetConfigAssistantStatsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConfigAssistantStatsRequest, GetConfigAssistantStatsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a summary of the versions of all modules that are in use by parts in the organization.
     *
     * @generated from protobuf rpc: GetOrgModuleVersionSummaries(fleetdashboard.v1.GetOrgModuleVersionSummariesRequest) returns (fleetdashboard.v1.GetOrgModuleVersionSummariesResponse);
     */
    getOrgModuleVersionSummaries(input: GetOrgModuleVersionSummariesRequest, options?: RpcOptions): UnaryCall<GetOrgModuleVersionSummariesRequest, GetOrgModuleVersionSummariesResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrgModuleVersionSummariesRequest, GetOrgModuleVersionSummariesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a summary of the versions of all fragments that are in use by parts in the organization.
     *
     * @generated from protobuf rpc: GetOrgFragmentVersionSummaries(fleetdashboard.v1.GetOrgFragmentVersionSummariesRequest) returns (fleetdashboard.v1.GetOrgFragmentVersionSummariesResponse);
     */
    getOrgFragmentVersionSummaries(input: GetOrgFragmentVersionSummariesRequest, options?: RpcOptions): UnaryCall<GetOrgFragmentVersionSummariesRequest, GetOrgFragmentVersionSummariesResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrgFragmentVersionSummariesRequest, GetOrgFragmentVersionSummariesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Per-part usage of a single fragment across the org's accessible fleet.
     *
     * @generated from protobuf rpc: GetOrgFragmentUsage(fleetdashboard.v1.GetOrgFragmentUsageRequest) returns (fleetdashboard.v1.GetOrgFragmentUsageResponse);
     */
    getOrgFragmentUsage(input: GetOrgFragmentUsageRequest, options?: RpcOptions): UnaryCall<GetOrgFragmentUsageRequest, GetOrgFragmentUsageResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrgFragmentUsageRequest, GetOrgFragmentUsageResponse>("unary", this._transport, method, opt, input);
    }
}
